<!-- <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
    <ul class="menu-inner py-1">
        <ng-container *ngFor="let un_menu of api.menu">
            <li class="menu-header small text-uppercase ">
                <span class="menu-header-text">{{un_menu.menu_header}}</span>
            </li>
            <ng-container *ngFor="let un_item of un_menu.items">
                <li *ngIf="un_item.items.length > 0" class="menu-item" [routerLinkActive]="'active'">
                    <a [routerLink]="[un_item.path]" class="menu-link menu-toggle">
                        <i class="menu-icon tf-icons bx" [class]="un_item.icone"></i>
                        <div data-i18n="Analytics">{{un_item.text}}</div>
                    </a>
                    <ul class="menu-sub">
                        <li *ngFor="let one_sub of un_item.items" class="menu-item" [routerLinkActive]="'active'">
                            <a [routerLink]="[one_sub.path]" class="menu-link">
                                <i class="menu-icon tf-icons bx" ></i>
                                <div data-i18n="Analytics">{{one_sub.text}}</div>
                            </a>
                        </li>
                    </ul>
                </li>
                <li *ngIf="un_item.items.length == 0" class="menu-item" [routerLinkActive]="'active'">
                    <a [routerLink]="[un_item.path]" class="menu-link">
                        <i class="menu-icon tf-icons bx" [class]="un_item.icone"></i>
                        <div data-i18n="Analytics">{{un_item.text}}</div>
                    </a>
                </li>
            </ng-container>
        </ng-container>
    </ul>
    <li class="menu-item" style="background-color: #f5f5f9;">
        <a href="javascript:void(0);" class="menu-link menu-toggle">
            <img src="../assets/img/our/avatar.png" alt
            class="w-px-40 h-auto rounded-circle me-2" />
            <div class="text-truncate" data-i18n="Layouts"> {{api.les_utilisateurs.length}} utilisateur(s) en ligne</div>
        </a>

        <div class="menu-sub">
            <div *ngFor="let un_utilisateur of api.les_utilisateurs" class="clique">
                <a class="menu-link">
                    <div data-i18n="Analytics" [ngClass]="{'text-warning':un_utilisateur.moi}">{{un_utilisateur?.titre}}</div>
                </a>
            </div>
        </div>
    </li>
</aside> -->

<aside class="dashboard-layout__sidebar sidebar">
  <div class="sidebar__logo">
    <img src="../../../assets/logo.png" alt="Logo" />
  </div>

  <nav class="sidebar__nav">
    <ul class="sidebar__list">
      @for (menu of api.menu; track menu.path) {
      <li class="sidebar__item">
        <a
          class="sidebar__link"
          [routerLink]="menu.path"
          routerLinkActive="sidebar__link--active"
          [routerLinkActiveOptions]="{ exact: false }"
        >
          <i [class]="menu.icone"></i>
          <span>{{ menu.title }}</span>
        </a>
      </li>
      }
    </ul>
  </nav>
</aside>
